// extracted by mini-css-extract-plugin
export default {"video-link":"s_b1 d-flex align-items-center my-2","video-link__link":"s_b2 ml-2"};